import { ConnectWithUsButton } from "../components/ConnectWithUsButton";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";

export const SchoolCTA = () => {
  const { t } = useSchoolLocal();

  return (
    <SchoolSection contentClassName="py-14 md:py-20">
      <div className="rounded-2xl bg-[#4242CE] px-6 py-12 text-center md:px-10">
        <SectionTitle className="mb-6 text-white">
          {t("cta.title")}
        </SectionTitle>
        <ConnectWithUsButton variant="inverted" />
      </div>
    </SchoolSection>
  );
};
